<template>
  <div>
    <div class="class-title">我的班級</div>
    <div v-show="!isLoading">
      <div v-if="courses.length>0" class="class-grid" id="course_container">
        <ClassCell v-for="course in courses" :key="course.courseId" :course="course" class="class-box"></ClassCell>
      </div>
      <h4 v-else id="no_course_description">沒有班級</h4>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<style scoped>
.class-title{
  color:#397f1f;
  font-size: 1.5rem;
  font-weight:600;
  margin-bottom: 1.5rem;
}

.class-grid{
  display: flex;
  flex-wrap: wrap;
  margin: auto;
}

</style>
<script>
import ClassCell from '@/components/Weeks/ClassCell.vue'
import Loading from '@/components/Utility/Loading.vue'
export default {
  data () {
    return {
      courses: [],
      isLoading: false
    }
  },
  components: {
    Loading,
    ClassCell
  },
  async created () {
    console.log('course home mounted')
    try {
      this.isLoading = true
      let courses = await this.$store.dispatch('request', {
        route: 'courses'
      })
      this.courses = courses.map(course => {
        course.noOfStudent = course.numOfStudents
        return course
      })
    } catch (err) {
      console.error(err)
      alert('更新失敗')
    }
    this.isLoading = false
  }
}
</script>
